import React from 'react';
import { Link } from "react-router-dom";
import { getRouteInfo } from '../route';
import { FEATURES_ROUTE_MAPPING } from '../constants';
import HeaderLink from './HeaderLink';

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDropDownToggled: false,
            isMenuActive: false,
            activeSubMenu: '',
        };
        this.toggleMenu = this.toggleMenu.bind(this);
        this.autoCloseDropDown = this.autoCloseDropDown.bind(this);
    }
    autoCloseDropDown(event) {
        if (this.state.isDropDownToggled) {
            // eslint-disable-next-line
            if (event.target != this.refs['dropdown-menu']) {
                this.setState({ isDropDownToggled: false })
                document.removeEventListener("click", this.autoCloseDropDown, false);
            }
        }
        if (this.state.isMenuActive && !(event.target.className.indexOf("sub-menu") >= 0)) {
            this.setState({ isMenuActive: false })
            document.removeEventListener("click", this.autoCloseDropDown, false);
        }
    }
    activateDropDown() {
        document.addEventListener("click", this.autoCloseDropDown, false);
        this.setState({ isDropDownToggled: true });
    }

    toggleMenu() {
        //only switch state when the menubar is in flex (aka non mobile view)
        if ((this.refs.menuDiv && window.getComputedStyle(this.refs.menuDiv).display !== 'flex') || (!this.refs.menuDiv)) {
            document.addEventListener("click", this.autoCloseDropDown, false);
            this.setState({ isMenuActive: true });
        }
    }
    triggerSubMenu(type) {
        this.setState({ activeSubMenu: type });
    }
    render() {
        let homelink = (this.props.isLoggedIn ? '/' : '/login');
        if(this.props.userType == "Salesperson")  homelink = '/salesperson';
        return (
            <header className='react-header'>
                <div className='container-fluid header-main-menu'>
                    <div className='div-container'>
                        <div className='row'>
                            <div className='col col-12 col-md-8 text-left'>
                                <div className='d-flex d-md-block'>
                                    <div className='user-menu-user-name d-flex d-md-none clickable d-print-none' onClick={this.toggleMenu.bind(this)}>
                                      {/* {(this.props.isLoggedIn && !this.props.hideMenu) ? (
                                      ): (false)} */}
                                      <span className='user-menu-user-icon clickable'><i className="material-icons">menu</i></span>
                                    </div>
                                    <Link to={homelink} className='company-logo-link text-center w-100'>
                                    {this.props.logoURL ? (
                                            <img src={this.props.logoURL} alt='company-logo' className='company-logo' />
                                    ) : (
                                            <h3 className='company-logo-as-text text-left'>{this.props.companyName}</h3>
                                    )}
                                    </Link>
                                </div>
                            </div>
                            {this.props.isLoggedIn ? (
                                <div className='d-none d-md-flex col col-12 col-md-4 justify-content-center flex-column'>
                                    <div className='user-menu d-print-none text-right'>
                                        <div className='user-menu-user-name clickable' >
                                            <div className='user-menu-language clickable'>
                                                <div className="btn-group">
                                                  <button type="button" className="user-menu-language-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    {this.props.language}
                                                  </button>
                                                  <div className="dropdown-menu dropdown-menu-right language-dropdown">
                                                    {window.LANGUAGES.map((language,key)=>{
                                                      return(
                                                        <button key={'language-'+key} className="dropdown-item user-menu-language-icon mb-2" type="button" onClick={this.props.switchLanguage.bind(this,language)}>{language}</button>
                                                      )
                                                    })}
                                                  </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='user-menu-user-name'>
                                            <span className='user-menu-user-icon clickable' onClick={this.activateDropDown.bind(this)}><i className="material-icons">account_circle</i></span>
                                        </div>
                                        <div className='user-menu-user-name clilckable' onClick={this.activateDropDown.bind(this)}>
                                            <span className='position-relative clickable'>
                                                {this.props.userName}<i className={"h6 mb-0 ml-1 fa fa-caret-" + (this.state.isDropDownToggled ? ("up") : ("down"))} aria-hidden="true"></i>
                                                <div ref='dropdown-menu' className={'dropdown-menu ' + (this.state.isDropDownToggled ? ('show') : (''))}>
                                                    <div className='header-link-sm'>
                                                        <Link to='/account' className='dropdown-menu-item' data-translation="header.account">My Account</Link>
                                                    </div>
                                                    <div className='header-link-sm'>
                                                        <Link to='/password' className='dropdown-menu-item' data-translation="header.password">Change Password</Link>
                                                    </div>
                                                    <div className='header-link-sm'>
                                                        <span className='btn btn-sm btn-info dropdown-menu-item clickable' onClick={this.props.logout} data-translation="header.logOut">Log Out</span>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                        {this.props.isLoggedIn && !this.props.hideMenu ? (
                                            <div className='user-menu-user-name d-md-none clickable' onClick={this.toggleMenu.bind(this)}>
                                                <span className='user-menu-user-icon clickable'><i className="material-icons">menu</i></span>
                                            </div>
                                        ) : (false)}
                                    </div>
                                    {this.props.isLoggedIn && this.props.salesperson? (
                                      <div className='user-menu d-print-none justify-content-md-between align-items-md-center'>
                                          <span className='mr-3'><b data-translation="header.customer">Customer</b></span>
                                          <span>{this.props.salesperson.customerName}</span>
                                          <Link to='/salesperson' className='btn btn-custom btn-saleperson-change' data-translation="general.change">Change</Link>
                                      </div>
                                    ) : (false)}
                                </div>
                            ) : (
                                <div className='col-12 col-md-4 d-flex text-right align-items-center justify-content-end'>
                                    <div className='user-menu-language clickable'>
                                        <div className="btn-group">
                                          <button type="button" className="user-menu-language-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {this.props.language}
                                          </button>
                                          <div className="dropdown-menu dropdown-menu-right language-dropdown">
                                            {window.LANGUAGES.map((language,key)=>{
                                              return(
                                                <button key={'language-'+key} className="dropdown-item user-menu-language-icon mb-2" type="button" onClick={this.props.switchLanguage.bind(this,language)}>{language}</button>
                                              )
                                            })}
                                          </div>
                                        </div>
                                    </div>
                                    {this.props.displayLogin ? (
                                            <div className='user-menu-user-name mr-0'>
                                                <span className='user-menu-user-icon mr-0'><i className="material-icons">account_circle</i></span>
                                            </div>
                                    ) : (false)}
                                    {this.props.displayLogin ? (
                                            <div className='header-link'>
                                                <Link to='/login' className='dropdown-menu-item' data-translation="header.login">Sign In</Link>
                                            </div>
                                    ) : (false)}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {this.props.isLoggedIn && !this.props.hideMenu ? (
                    <div className='div-container position-relative d-print-none '>
                        <div ref='menuDiv' className='d-none d-md-flex header-link-list'>
                            <HeaderLink onClick={this.toggleMenu} target={getRouteInfo('home')} translationTag='home' />
                            {(this.props.features) ? (this.props.features).map((item, key) => {
                                if (!FEATURES_ROUTE_MAPPING[item]) return false;
                                return (
                                    <HeaderLink
                                        key={'header-link-' + item}
                                        onClick={this.toggleMenu}
                                        target={getRouteInfo(FEATURES_ROUTE_MAPPING[item].pathName)}
                                        translationTag={FEATURES_ROUTE_MAPPING[item].pathName}
                                    />
                                )
                            }) : (false)}
                            {(this.props.customization) ? (this.props.customization).map((item, key) => {
                                return (
                                    <HeaderLink
                                        key={'header-link-' + item}
                                        onClick={this.toggleMenu}
                                        target={{path:item.url , desc:item.name}}
                                    />
                                )
                            }) : (false)}
                        </div>
                    </div>
                ) : (false)}
                <div className={'div-mobile-menu d-block d-md-none ' + ((this.state.isMenuActive) ? ('show') : (''))} id='side-menu'>
                    {this.props.isLoggedIn ? (
                        <div>
                            <div className='div-mobile-main-menu'>
                                <HeaderLink onClick={this.toggleMenu} target={getRouteInfo('home')} translationTag='home' />
                                {!this.props.hideMenu ? (
                                  <div>
                                    {(this.props.features) ? (this.props.features).map((item, key) => {
                                      if (!FEATURES_ROUTE_MAPPING[item]) return false;
                                      return (
                                        <HeaderLink
                                          key={'header-link-' + item}
                                          onClick={this.toggleMenu}
                                          target={getRouteInfo(FEATURES_ROUTE_MAPPING[item].pathName)}
                                          translationTag={FEATURES_ROUTE_MAPPING[item].pathName}
                                        />
                                      )
                                    }) : (false)}
                                  </div>
                                ):(false)}
                                <div className='header-link' onClick={this.triggerSubMenu.bind(this, 'accountMenu')}>
                                    <div className='sub-menu'>My Account</div>
                                </div>
                            </div>
                            <div className={'div-mobile-sub-menu ' + ((this.state.activeSubMenu === 'accountMenu') ? ('showing') : (''))} ref='accountMenu'>
                                <div className='sub-menu-return sub-menu' onClick={this.triggerSubMenu.bind(this, '')}>
                                    <span><i className="fa fa-chevron-left sub-menu" aria-hidden="true"></i><b className='sub-menu'>Home</b></span>
                                </div>
                                <div className='header-link'>
                                    <div className='sub-menu-header'>Account Information</div>
                                </div>
                                <HeaderLink onClick={this.toggleMenu} target={getRouteInfo('myAccount')} translationTag='header.account' />
                                <HeaderLink onClick={this.toggleMenu} target={getRouteInfo('password')} translationTag='header.password' />
                                <div className='header-link'>
                                    <div className='' onClick={this.props.logout} data-translation="header.logOut">Log Out</div>
                                </div>
                            </div>
                        </div>
                    ) : (
                          <div className='div-mobile-main-menu'>
                                <HeaderLink onClick={this.toggleMenu} target={getRouteInfo('login')} translationTag='login' />
                        </div>
                    )}
                </div>
            </header>
        );
    }
}
